import { Link } from 'react-router-dom'
import Seo from '../../components/Seo'
import { brand } from '../../brand'

export default function Privacy() {
  return <>
    <Seo title="Privacy and data use" />
    <section className="hero">
      <span className="eyebrow">Privacy and data use</span>
      <h1 style={{marginTop: '0.75rem'}}>Supplier screening and your information</h1>
      <p className="lede">This page explains the information used in Ledgerline screening and how to contact us about it.</p>
    </section>
    <section className="section" id="outreach" aria-labelledby="outreach-title">
      <h2 id="outreach-title">Received an inquiry from Ledgerline?</h2>
      <dl className="deflist">
        <dt>Why we contacted you</dt>
        <dd>Our message asks about products or services your company may provide. Refer to that message for the requirement and the information requested. An inquiry is not an order or a promise of selection.</dd>
        <dt>How to respond</dt>
        <dd>Reply to the email you received, or call <a href={`tel:${brand.callbackNumber.replace(/[^+\d]/g, '')}`}>{brand.callbackNumber}</a>. Have the callback reference from your invitation ready.</dd>
        <dt>Automated calls</dt>
        <dd>The screening assistant is automated. It identifies itself and requests consent to recording before screening. Calls may produce recordings, transcripts, and structured answers. If you do not want to participate by phone, reply by email. You can decline questions or request contact from a person.</dd>
        <dt>Stop further outreach</dt>
        <dd>Use the opt-out link in your invitation, request removal during a call, or visit the <Link to="/opt-out">opt-out page</Link>.</dd>
      </dl>
    </section>
    <section className="section">
      <dl className="deflist">
        <dt>Contact</dt>
        <dd>{brand.name}<br />{brand.mailingAddress}<br /><a href={`mailto:${brand.privacyEmail}`}>{brand.privacyEmail}</a></dd>
        <dt>Information collected</dt>
        <dd>Company research, business contact details, inquiry form submissions, emails and attachments, call recordings and transcripts, and responses to screening questions. Signed-in analyst access also uses session cookies.</dd>
        <dt>Use and processing</dt>
        <dd>These records support supplier research, screening, comparison, follow-up, and operation of the service. Authorized analysts can review them. Hosting, email, telephony, and AI service providers process information used by these features.</dd>
        <dt>Stored records</dt>
        <dd>Screening records and supporting material are stored for review and follow-up, including in backups. Contact us to ask about the records associated with your company, retention, correction, or deletion. We review these requests individually.</dd>
        <dt>Website inquiries</dt>
        <dd>The contact form saves the details you submit in the team’s inbox. Please avoid sending sensitive personal information or confidential material that is not needed for your request.</dd>
      </dl>
    </section>
  </>
}
